export default function CommonProjects() {
  const projects = [
    {
      name: 'Home Repairs & Maintenance',
      description: 'Keep your home in top condition with regular maintenance and quick repairs for common household issues.',
      tasks: ['Fix leaky faucets', 'Repair drywall damage', 'Replace door hardware', 'Caulking and sealing'],
      image: 'https://public.readdy.ai/ai/img_res/e05aa95d5d893a99614d6163420f001e.jpg'
    },
    {
      name: 'Installation Services',
      description: 'Professional installation of fixtures, appliances, and home accessories for functionality and aesthetics.',
      tasks: ['Mount TVs and shelves', 'Install ceiling fans', 'Assemble furniture', 'Install blinds and curtains'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20handyman%20mounting%20flat%20screen%20TV%20on%20living%20room%20wall%2C%20careful%20installation%20with%20level%20and%20proper%20tools%2C%20clean%20contemporary%20interior%20showing%20precise%20workmanship%2C%20emphasis%20on%20professional%20home%20installation%20services&width=500&height=350&seq=handyman-install-001&orientation=landscape'
    },
    {
      name: 'Painting & Touch-ups',
      description: 'Refresh your home\'s appearance with professional painting services for interior and exterior surfaces.',
      tasks: ['Interior room painting', 'Exterior touch-ups', 'Cabinet refinishing', 'Trim and baseboard painting'],
      image: 'https://readdy.ai/api/search-image?query=Skilled%20handyman%20painting%20interior%20wall%20with%20roller%2C%20clean%20painting%20technique%20in%20bright%20residential%20room%2C%20professional%20drop%20cloths%20and%20organized%20workspace%2C%20emphasis%20on%20quality%20painting%20service%20and%20neat%20workmanship&width=500&height=350&seq=handyman-paint-001&orientation=landscape'
    },
    {
      name: 'Outdoor Projects',
      description: 'Enhance your outdoor spaces with repairs, installations, and improvements for curb appeal and functionality.',
      tasks: ['Fence repairs', 'Deck maintenance', 'Gutter cleaning', 'Outdoor lighting installation'],
      image: 'https://readdy.ai/api/search-image?query=Handyman%20repairing%20wooden%20fence%20in%20El%20Paso%20backyard%2C%20professional%20outdoor%20repair%20work%20with%20tools%2C%20bright%20sunny%20day%20showing%20quality%20craftsmanship%2C%20desert%20landscape%20background%2C%20emphasis%20on%20reliable%20outdoor%20maintenance%20services&width=500&height=350&seq=handyman-outdoor-001&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-emerald-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Common Handyman Projects in El Paso
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Explore the most popular handyman services requested by El Paso homeowners.
          </p>
        </div>

        <div className="space-y-12">
          {projects.map((project, index) => (
            <div 
              key={index}
              className={`bg-white rounded-2xl shadow-lg overflow-hidden ${
                index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
              } flex flex-col lg:flex`}
            >
              <div className="lg:w-1/2 relative h-80 lg:h-auto">
                <img 
                  src={project.image}
                  alt={project.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="lg:w-1/2 p-10">
                <h3 className="text-3xl font-bold text-gray-900 mb-4">
                  {project.name}
                </h3>
                <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                  {project.description}
                </p>
                <div className="grid grid-cols-2 gap-4">
                  {project.tasks.map((task, idx) => (
                    <div key={idx} className="flex items-center gap-2">
                      <i className="ri-checkbox-circle-fill text-emerald-600 text-xl"></i>
                      <span className="text-gray-700 font-medium">{task}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
